import {Component, inject, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService } from '@wms/services';
import { BaseComponent } from '@wms/components';
import { CodeInspectService, ImportProjectComponent, ShortcutsDialogComponent } from '@wms/bottom-left-menu';
import { WmsFeatureDirective } from '@wms/directives';
import { Router } from '@angular/router';
import { runtimeEventManager } from '@wm/core';
import { addResizableClass} from "@wms/core";
import {getLocalStorageItem} from "../../../../../projects/core/src/utils/studio-user-preferences";
import { IssuesService } from '../issues/issues.service';
import {WmsWorkspaceManagerService} from "@wms/workspace";


@Component({
  selector: 'wms-more-actions-menu',
  standalone: true,
  imports: [
    CommonModule,
    WmsFeatureDirective,
    ShortcutsDialogComponent,
    ImportProjectComponent
  ],
  templateUrl: './more-actions-menu.component.html',
  styleUrls: ['./more-actions-menu.component.less']
})
export class MoreActionsMenuComponent extends BaseComponent {
  @Input() openIssueTab:boolean;
  public wsManager: WmsWorkspaceManagerService;

  issuesIntroDone: boolean;

  constructor(private dialogService: DialogService, public codeInspectService: CodeInspectService, private router: Router, public issuesService: IssuesService) {
    super();
    this.wsManager = inject(WmsWorkspaceManagerService);
    this.issuesService.isFirstChecked = getLocalStorageItem('issues-intro-done') === 'true' ? true : false;
  }

  showShortcutsDialog() {
    this.dialogService.open("shortcutsDialog");
  }

  closeDialogWithId(id: any) {
    this.dialogService.close(id);
  }


  /**opens the inspect errors list**/
  inspectApp() {
    this.codeInspectService.isInspectCodeEnabled = true;
    addResizableClass('wm-studio-content-inspect-errors');
  }

  showIssuesTab() {
    this.eventManager.emitopenAppIssuesTab('wms-issues-tab');
  }

  reimportProject() {
    this.dialogService.open('importProjectDialog');
  }

  editAppJs() {
    let selectedFileInfo = {
      name: 'app.js',
      relativePath: '/src/main/webapp/app.js',
      path: '../project/src/main/webapp/app.js',
      type: "file"
    };
    if (this.router.url.startsWith('/files')) {
      runtimeEventManager.emit('loadResource', selectedFileInfo);
    }
    else {
      this.router.navigate(['/files', selectedFileInfo]);
    }
  }
    savetabcontent(event: any): void {
        if (this.wsManager?.isWSDirty()) {
            event.preventDefault();
            this.wsManager.saveActiveWs.next(() => {
            });
            return;
        }
    }
  editAppCss() {
    let selectedFileInfo = {
      name: 'app.css',
      relativePath: '/src/main/webapp/app.css',
      path: '../project/src/main/webapp/app.css',
      type: "file"
    };
    if (this.router.url.startsWith('/files')) {
      runtimeEventManager.emit('loadResource', selectedFileInfo);
    }
    else {
      this.router.navigate(['/files', selectedFileInfo]);
    }
  }
}
